// AtomParts/Title.tsx
import React from "react";

interface TitleProps {
  children: React.ReactNode;
  sizeDesktop?: string;
  sizeMobile?: string;
}

const Title: React.FC<TitleProps> = ({ children }) => <h2 className="text-2xl font-semibold">{children}</h2>;

export default Title;
